import EmpArticles from './EmployeeArticles';
import ManArticles from './ManagerArticles';
import PSArticles from './PlanSponsorArticles';

export const EmployeeArticles = EmpArticles;
export const ManagerArticles = ManArticles;
export const PlanSponsorArticles = PSArticles;
